module.exports = __webpack_public_path__ + "img/settsu-motoyama.a52cb9b.png";